<template id="app">
<v-card class="overflow-hidden v-card v-sheet theme--light mt-0 v-card-100 px-0">
<!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <!-- <header-component :headerTitle="headerText" /> -->
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
     <!-- Generate Box ID popup -->
    <v-row justify="center">
      <v-dialog v-model="generateBoxDialog" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-0">
              <v-row class="ma-1">
              <span style="font-weight: 600;">Generate Box Id's</span>
              <v-spacer></v-spacer>
                <v-icon @click="generateBoxDialog = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
            <v-card-text>
              <v-container>
                <v-row  justify="center">
                  <v-col cols="6">
                    <v-autocomplete 
                       v-model="to_location" 
                       :items="to_location_items" 
                       item-title="code"
                       item-value="id" 
                       return-object 
                       label="To Location" 
                       variant="outlined"
                       ref="comboboxRef"
                       @focus="printWidth"
                       :menu-props="{ width: dynamic_width }"
                       >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete 
                      v-model="from_location" 
                      :menu-props="{ width: dynamic_width }" 
                      :items="from_location_items" 
                      item-title="code" 
                      item-value="id" 
                      return-object 
                      label=" From Location"
                      ref="comboboxRef"
                      @focus="printWidth" 
                      variant="outlined">
                    </v-autocomplete>
                  </v-col>                  
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="quantity" label="Quantity" type="number" min="1" @update:modelValue="quantity < 1 ? quantity = null : quantity" required variant="outlined"></v-text-field>
                  </v-col>
                <v-col cols="6">
                    <v-text-field v-model="orrd_no" label="ORRD No." :rules="[numberRule]" required variant="outlined"></v-text-field>
                  </v-col>
                </v-row>
                 <v-row>
                  <v-col cols="6">
                    <v-autocomplete 
                      v-model="logistics_partner" 
                      :items="logistics_partner_items" 
                      item-title="name" 
                      item-value="id" 
                      return-object 
                      label="Logistics Partner"
                      ref="comboboxRef"
                       @focus="printWidth"
                       :menu-props="{ width: dynamic_width }"
                      variant="outlined">
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" x-large color="primary" class="cancel-color mb-3 text-none" @click="generateBoxDialog = false">Cancel</v-btn>
            <v-btn color="primary" x-large class="mb-3 text-none" variant="flat" :disabled="!to_location || !from_location || !quantity || !orrd_no || !logistics_partner" @click="requestSubmission">Generate</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
     <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent :max-width="organization_name === 'Voltas' ? '1224px' : '600px'">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-row class="mt-2">
              <v-col cols="6">
              <v-text-field v-model="orrd_no_filter" label="ORRD No." type="number" min="1" required variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="6">
              <v-combobox prepend-inner-icon="mdi-magnify" v-model="status" :items="status_items" label="Status" variant="outlined" > </v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn class="text-none" size="small" variant="outlined" color="primary" @click="filteWithSubPopup = false">Cancel</v-btn>
            <v-btn class="text-none" size="small" variant="flat" color="primary" @click="applyFilter('filter')">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- seacrh, action button and filter -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-0 mt-4">
      <!-- Search fields -->
      <v-row class="ma-1">
        <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="getUsers"></v-text-field>
          <v-spacer></v-spacer>
        <v-card-actions class="mb-4">
          <v-btn class="mr-2 custum-button text-none" variant="flat" :disabled="(selected.length === 1)" @click="openGenerateBoxDialog" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Generate</v-btn>
          <v-btn class="mr-2 custum-button text-none" variant="flat" :disabled="selected.length === 0" @click="downloadTrack()" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
        </v-card-actions>
        <!-- Filter -->
        <v-expansion-panels class="custom-control_outlined m-0 pt-2" ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; height: 56px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" 
          class="elevation-1"
          return-object
          >
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
            <span v-if="header.key == 'print'">
                <v-btn class="m-2 text-none" color="blue-darken-4" variant="outlined" @click="updatePrintStatus(item)" style="color: #1976d2;">
                 Print
                </v-btn>
              </span> 
              <span v-else-if="header.key == 'download'">
                <v-btn class="m-2 text-none" color="blue-darken-4" variant="outlined" @click="downloadTrack(item)" style="color: #1976d2;">
                 Download
                </v-btn>
              </span>
              <span v-else-if="header.key == 'scheduled_at'">
               <span>{{formatScheduledDateTime(item.scheduled_at)}}</span>
              </span>
              <span v-else>{{ item[header.key] ? item[header.key] : '-' }}</span>
            </template>
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
</v-card>
</template>
<script>
// import HeaderComponent from "./../../../commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {    
    // components: {
    //     HeaderComponent,
    // },
  data() {
        return {
            headerText: "Generate Box ID",
            alert : false,
            alert_type : "success",
            alert_message : '',
            search_tag: '',
            loading : false,
             snackbar: {
              color: null,
              icon: null,
              mode: null,
              position: "top",
              text: null,
              timeout: 7500,
              title: null,
              visible: false
              },
              selected:[],
            headers : [],
            table_data : [],
            number: 0,
            page: 1,
            totalPages: 1,
            totalCount: '',
            pageSize: defaultPageSize,
            pageSizes: defaultPageSizes,
            generateBoxDialog:false,
            to_location:null,
            to_location_items:[],
            from_location:null,
            from_location_items:[],
            quantity:null,
            orrd_no:null,
            logistics_partner:null,
            logistics_partner_items:[],
            dynamic_width:'',
            gene_date_time: null,
            isDatePickerBidStartDate: new Date(),
            menu1: false,
            filteWithSubPopup: false,
            status_items: ['Pending', 'Completed'],
            status:null,
            orrd_no_filter:'',
            isSearchFiltering: false,
            barcodeNumbers:[],
            box_ids:[],
            latestPrintData:'',
        }
    },
  computed: {
        formattedStartDate() {
          if (this.gene_date_time) {
            const date = new Date(this.gene_date_time);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();

            const hours = new Date().getHours().toString().padStart(2, '0');
            const minutes = new Date().getMinutes().toString().padStart(2, '0');
            const seconds = new Date().getSeconds().toString().padStart(2, '0');
            console.log(`${day}.${month}.${year} / ${hours}:${minutes}:${seconds}`);

            return `${day}.${month}.${year} / ${hours}:${minutes}:${seconds}`;
          }
          return '';
        }
      },
  created(){
        this.loadData();
      },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 5000);
      },
     loadData(){
        this.search_tag = '';
        this.select_field = null;
        // this.download_message = ''
        this.loading = false;
        this.isFiltering = false;
        this.isSearchFiltering = false;
         this.headers = [
          { title: "Generation Date & Time", key: "scheduled_at"},
          { title: "Generated By", key: "generated_by"},
          { title: "Generated Quantity", key: "quantity" },
          { title: "ORRD No", key: "orrd_no" },
          { title: "Print Status", key: "status" },
          { title: "", key: "print" },
          { title: "", key: "download" },
        ];
        this.selected = []
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.successPopup = false;       
        this.getUsers();      
      },
      getUsers() {
        this.loading = true;
        const params = {
            page: this.page,
            per_page: this.pageSize,
            search: this.search_tag
        };
        let end_point = '/api/v2/box_generation_requests';
        this.$httpSecured
            .get(end_point, { params })
            .then(response => {
            if (response && response.data) {
                this.table_data = response.data.box_generation_requests;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
            } else {
                this.showAlert("error", "No Data Found");
            }
            this.loading = false;
            })
            .catch(error => {
            const errorMsg = error?.response?.data?.error || "Something went wrong";
            this.showAlert("error", errorMsg);
            this.loading = false;
            });
        },
        formatScheduledDateTime(datetime) {
          if (!datetime) return '';

          const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
          };

          const formatted = new Date(datetime).toLocaleString('en-IN', options);
          return formatted.replace(',', ' &'); // Optional: To match your format
        },
     printWidth() {
        this.$nextTick(() => {
            const combobox = this.$refs.comboboxRef?.$el;
            if (combobox) {
            const inputControl = combobox.querySelector(".v-input__control");
            if (inputControl) {
                this.dynamic_width = inputControl.offsetWidth + "px"
            }
            }
        });
        },
      handlePageSizeChange(size){
        this.pageSize = size;
        this.page = 1
        if(this.isSearchFiltering){
          this.applyFilter('search');
          return;
        }else if(this.isFiltering){
          this.applyFilter('filter');
          return;
        }
        this.getUsers()
      },
      handlePageChange(value) {
        this.page = value;
        if(this.isFiltering){
          this.filterPage = value;
          this.applyFilter('filter');
          return;
        }else if(this.isSearchFiltering){
          this.applyFilter('search');
          return;
        }
        this.getUsers()
      },
      openGenerateBoxDialog(){
        this.generateBoxDialog = true;
        this.to_location = null;
        this.from_location = null;
        this.gene_date_time = null;
        this.quantity = null;
        this.orrd_no = null;
        this.logistics_partner = null
        this.getDataOfpartner();
      },
      getDataOfpartner() {
      this.$httpSecured
        .get('/api/v2/box_generation_requests/logistics_partners_and_distribution_centers')
        .then(response => {
          this.logistics_partner_items = response.data.logistics_partners;
          this.to_location_items = response.data.distribution_centers; 
          this.from_location_items = response.data.reverse_distribution_centers;
        })
        .catch((error) => {
            this.$toast.error("Error fetching brand data:", error);
          });
    },
      handleSaveDate(dateType, dateState, selectDateState) {
        console.log('date',this[selectDateState]);
          this[dateState] = this[selectDateState];
          this[dateType] = false;
        },
    requestSubmission() {
        this.number++;
        const payload = {
          box_generation_request: {
            from_location_id: this.from_location.id,
            to_location_id: this.to_location.id,
            quantity: this.quantity,
            orrd_no: this.orrd_no,
            logistics_partner: this.logistics_partner.name,
            logistics_partner_id: this.logistics_partner.id,
            from_location_code: this.from_location.code,
            to_location_code: this.to_location.code
          }
        };

        this.$httpSecured
          .post('/api/v2/box_generation_requests', payload)
          .then((response) => {
            if (response.data) {
              this.generateBoxDialog = false;
              this.snackbar = {
                      color: "success",
                      icon: "mdi-check-circle",
                      mode: "multi-line",
                      position: "bottom",
                      timeout: 3000,
                      title: "Success",
                      text: response.data.message,
                      visible: true
                    };
                  this.selected = [];
                  this.number = 0;
              this.loadData(this.active_tab);
            } else {
              this.showAlert('error', 'No Data Found');
            }
            this.loading = false;
          })
          .catch((error) => {
            this.$toast.error(error?.response?.data?.message || 'Submission failed');
            this.loading = false;
          });
      },
      updateFromLocation() {
        this.from_location_items = this.from_location_items.filter(item => item.id !== this.to_location.id);
      },
      downloadTrack(item) {
          const params = {
            box_ids: this.selected.length > 0 ? this.selected.map(selectedItem => selectedItem.id) : [item.id]
          };
          this.$httpSecured
            .post('/api/v2/box_generation_requests/download_box_id', params)
            .then(response => {
              if (response.data) {
                const url = response.data.url;
                const link = document.createElement('a');
                link.href = url;
                link.download = '';
                document.body.appendChild(link);
                link.click();
                this.snackbar = {
                  color: "success",
                  icon: "mdi-check-circle",
                  mode: "multi-line",
                  position: "top",
                  timeout: 3000,
                  title: "Success",
                  text: "(CSV File) Downloaded Successfully",
                  visible: true
                };
                this.selected = [];
                this.number = 0;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
                this.number = 0;
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
              this.number = 0;
            });
        },
      filterListOfButtons() {
        this.filteWithSubPopup = true;
        this.status = null;
        this.orrd_no_filter = null;
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      },
      applyFilter(value) {
        this.loading = true;   
        this.isFiltering = false;
        this.isSearchFiltering = false;     
        const payload = {
            page: this.page,
            per_page: this.pageSize,
            filter: {}
          };

        if (value === 'filter') {
          this.isFiltering = true;
          this.search_tag = '';
          payload.filter['orrd_no'] = this.orrd_no_filter;
          payload.filter['status'] = this.status;
        }
        let end_point = '/api/v2/box_generation_requests';
        this.$httpSecured
          .get(end_point, {params: payload})
          .then(response => {
            if (response.data) {
              this.table_data = response.data.box_generation_requests
              this.filteWithSubPopup = false;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
    updatePrintStatus(item) {
        this.$httpSecured
          .get(`api/v2/box_generation_requests/${item.id}/print_box_id`)
          .then(response => {
            if (response.data) {
              this.latestPrintData = response.data.box_generation_request;
              const tagNumbers = response.data.box_generation_request.box_ids;
              this.box_ids = tagNumbers.map(item => item);
              this.barcodeNumbers = tagNumbers.map(item => item);
              this.generateAndPrintBarcodes();
            } else {
              this.showAlert("error", error.response.data.error);
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
            this.change_status = false
          });
      },

     generateAndPrintBarcodes() {
        const previewWindow = window.open('', 'PRINT', 'height=400,width=600');
        previewWindow.document.write('<html><head><title>Barcode Preview</title>');
        previewWindow.document.write('<style>');
        previewWindow.document.write(`
          @media print {
            @page {
              size: 3in 3in;
              margin: 0;
            }
            body, html {
              margin: 0;
              padding: 0;
            }
            .label {
              width: 3in;
              height: 3in;
              padding: 10px;
              box-sizing: border-box;
              font-family: Arial, sans-serif;
              font-size: 11px;
              page-break-after: always;
              border: 1px solid #000;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              position: relative;
            }
            .top-barcode {
              position: relative;
              top: 0px;
              left: 150px;
            }
            .barcode {
              text-align: center;
              margin: 5px 0;
            }
            .top-barcode canvas {
              width: 100px !important;  
              height: 30px !important;
            } 
            .barcode canvas {
              width: 100px !important;  
              height: 30px !important;
            }
          }
        `);
        previewWindow.document.write('</style></head><body>');

        const data = this.box_ids;
        const info = this.latestPrintData;

        // Check route_id value
        const routeIdValue = info.route_id && info.route_id.trim() !== '' ? info.route_id : null;

        data.forEach((boxId, index) => {
          const routeCanvasId = `routeBarcodeCanvas_${index}`;
          const boxCanvasId = `boxBarcodeCanvas_${index}`;

          previewWindow.document.write(`<div class="label">`);

          // Only write route barcode if routeIdValue is not null
          if (routeIdValue) {
            previewWindow.document.write(`
              <div class="top-barcode"><canvas id="${routeCanvasId}"></canvas></div>
            `);
          }

          previewWindow.document.write(`
            <div><strong>To:</strong> ${info.to_location_code.slice(0, 18)}</div>
            <div><strong>From:</strong> ${info.from_location_code.slice(0, 18)}</div>
            <div><strong>Storage Type:</strong></div>
            <div><strong>Pick Area:</strong></div>
            <div class="barcode"><canvas id="${boxCanvasId}"></canvas></div>
            <div><strong>Transfer Order:</strong> ${info.orrd_no}</div>
            <div><strong>Date / Time:</strong> ${this.getCurrentFormattedDateTime()}</div>
          `);

          previewWindow.document.write(`</div>`);
        });

        previewWindow.document.write('</body></html>');
        previewWindow.document.close();

        previewWindow.onload = () => {
          data.forEach((boxId, index) => {
            const boxCanvas = previewWindow.document.getElementById(`boxBarcodeCanvas_${index}`);
            if (boxCanvas) {
              JsBarcode(boxCanvas, boxId, {
                fontSize: 14,
                height: 40,
                width: 1.8,
                displayValue: true,
                margin: 0,
                fontOptions: "600",
              });
            }

            // Generate route barcode only if routeIdValue exists
            if (routeIdValue) {
              const routeCanvas = previewWindow.document.getElementById(`routeBarcodeCanvas_${index}`);
              if (routeCanvas) {
                JsBarcode(routeCanvas, routeIdValue, {
                  fontSize: 12,
                  height: 30,
                  width: 1.5,
                  displayValue: true,
                  margin: 0,
                });
              }
            }
          });

          previewWindow.focus();
          previewWindow.print();
        };
      },
     getCurrentFormattedDateTime() {
          const now = new Date();
          let hours = now.getHours();
          const minutes = now.getMinutes();
          const ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12 || 12; // Convert 0 to 12
          const paddedMinutes = minutes < 10 ? `0${minutes}` : minutes;
          const formattedDate = now.toLocaleDateString(); // e.g., 6/2/2025
          return `${formattedDate} ${hours}:${paddedMinutes} ${ampm}`;
        },
    }
}
</script>
<style scoped>
.v-dialog:has(.filter-dispatch) {
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }

  .v-dialog>.v-card>:has(.v-card__title) {
    overflow-wrap: break-word !important;
  }

  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }
  .v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 310px) !important;
}
</style>
